import { createTheme, type Theme } from '@mui/material'
import Portal from '@mui/material/Portal'
import * as colors from './colors'
import { defaultComponents } from './components'
import { typography } from './typography'

export const createCustomTheme = () => {
  const basicTheme = createTheme({
    palette: {
      ...colors,
      primary: {
        lightest: colors.blue['100'],
        lighter: colors.blue['300'],
        light: colors.blue['500'],
        main: colors.blue['600'],
        dark: colors.blue['700'],
        contrastText: '#fff',
      },
      secondary: {
        light: colors.grey['200'],
        main: colors.grey['500'],
        dark: colors.grey['500'],
        contrastText: '#fff',
      },
      text: {
        primary: colors.grey['900'],
        secondary: colors.grey['700'],
        disabled: colors.grey['500'],
      },
    },
    typography,
    components: defaultComponents(),
    spacing: 8,
  })

  const shadows = getThemeShadows(basicTheme)

  const pandaTheme = createTheme(basicTheme, {
    shadows: shadows,
  })

  return pandaTheme
}

function getThemeShadows(theme: Theme) {
  return Array.from(
    theme.shadows.map((shadow, index) => {
      switch (index) {
        case 1:
          // base350
          return shadow.replace(/rgba\(0,0,0/g, 'rgba(199, 199, 199')
        case 2:
        case 3:
          // base400
          return shadow.replace(/rgba\(0,0,0/g, 'rgba(179, 179, 180')
        case 5:
        case 10:
          // base500
          return shadow.replace(/rgba\(0,0,0/g, 'rgba(104, 103, 106')
        default:
          return shadow
      }
    }),
  )
}

export const FontLoader = () => {
  return (
    <Portal container={document.head}>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <style>
        {`@font-face {
          src: url(/fonts/Mynt-Sans-Display-Medium.woff2) format('woff2');
          font-family: 'Mynt Sans Display';
          font-weight: 500;
          font-style: normal;
          font-display: swap;
        }`}
      </style>
    </Portal>
  )
}
